import Box from "@mui/material/Box";
import React from "react";
import { Link } from "react-router-dom";
import { useAppConfig } from "../../../security/ApplicationProvider/ApplicationProvider";
import { useTheme } from "@mui/material";
import { useBillingCompanyContext } from "../../../providers";

export const LogoIcon: React.FC<{
  isLoginPage?: boolean;
  alignment?: string;
}> = (props) => {
  const { alignment = "center", isLoginPage = false } = props;

  const companyOutlet = useBillingCompanyContext();

  let { logo } = useAppConfig();

  const theme = useTheme();

  const CompanyOutletLogo = `https://enr-biolerplate.s3.ap-south-1.amazonaws.com/${companyOutlet.comapny.logo}`;

  return (
    <Link to="/" style={{ textDecoration: "none" }}>
      <Box
        display={"flex"}
        justifyContent={alignment}
        alignItems="center"
        sx={{
          py: 1,
          maxWidth: isLoginPage ? "inherit" : "180px",
          height: isLoginPage ? "auto" : "50px",
          [theme.breakpoints.up("sm")]: {
            width: isLoginPage ? "120px" : "140px",
            height: isLoginPage ? "auto" : "50px",
          },
          [theme.breakpoints.up("md")]: {
            width: isLoginPage ? "150px" : "160px",
            height: isLoginPage ? "auto" : "55px",
          },
          [theme.breakpoints.up("lg")]: {
            width: isLoginPage ? "200px" : "180px",
            height: isLoginPage ? "auto" : "60px",
          },
          [theme.breakpoints.up("xl")]: {
            width: isLoginPage ? "250px" : "200px",
            height: isLoginPage ? "auto" : "65px",
          },
        }}
      >
        <img
          src={companyOutlet?.comapny.logo ? CompanyOutletLogo : logo}
          alt="logo not found"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "left center",
          }}
        />
      </Box>
    </Link>
  );
};
